export enum NOTIFICATION_UPDATE_ACTION {
  DELETE,
  STATUS,
  READ,
}